import { MessageKey } from "./message-key.js";
export function isMessageKey(x) {
    return typeof x === `string` && Object.values(MessageKey).includes(x);
}
//# sourceMappingURL=types.js.map